import { getCommonFilterConfig } from '@bingads-webui-campaign/common-grid-config';
import odataSchemas from '@bingads-webui-campaign/campaign-ui-schemas';
import { sessionStore } from '@bingads-webui/js-data-storage';
import { FilterService } from '@bingads-webui/filter-service';
import { updateGridQuery } from '@bingads-webui-campaign/summary-grid-helper';
import { isDataExclusion } from './adjustment-type';

export function getFilterConfig({
  i18n,
  globalConfig,
  preferenceService,
  preferenceStoreFactory,
  getGridView,
  adjustmentType,
}) {
  const searchboxPlaceholderText = isDataExclusion(adjustmentType) ? _TL_('Data exclusion name') : _TL_('Seasonality adjustment name');
  const featureName = isDataExclusion(adjustmentType) ? 'DataExclusionGrid' : 'SeasonalityAdjustmentGrid';
  const filterConfig = getCommonFilterConfig({
    i18n,
    featureName,
    entitySchema: odataSchemas.SeasonalityAdjustment,
    globalConfig,
    preferenceService,
    preferenceStoreFactory,
    sessionStore,
    enableCampaignWaterfall: false,
    allowCampaignTypeWaterfall: false,
    updatePilot: false,
    searchbox: {
      placeholder: i18n.getString(searchboxPlaceholderText),
      searchProperty: 'Name',
      searchOperator: '$contains',
    },
  });

  const filterService = new FilterService(filterConfig);

  filterService.on('filter-state-changed', (combinedFilter /* subStatus */) => {
    const gridView = getGridView();
    if (gridView) {
      updateGridQuery(gridView, combinedFilter.filter, true);
    }
  });

  return {
    ...filterConfig,
    filterService,
  };
}

